import { ConvergeTooltip } from '../../../../presentation/components';
import { Typography } from '@mui/material';

export const NotApplicable = ({ tooltipText = 'Not applicable/available' }) => {
  return (
    <ConvergeTooltip title={tooltipText}>
      <Typography color="text.disabled" fontWeight={600} fontSize="14px">
        $0
      </Typography>
    </ConvergeTooltip>
  );
};
